import { DateRange } from 'react-day-picker'

/**
 * Нормализует диапазон дат для API запросов
 * @param dateRange - диапазон дат из DatePicker
 * @returns объект с startDate и endDate в формате ISO string
 */
export const normalizeDateRange = (dateRange?: DateRange) => {
  // Нормализуем дату для корректного запроса статистики в пределах суток
  const normalizeDate = (date: Date, isEndDate = false) => {
    const normalized = new Date(date)
    if (isEndDate) {
      normalized.setHours(23, 59, 59, 999)
    } else {
      normalized.setHours(0, 0, 0, 0)
    }
    return normalized.toISOString()
  }

  // Используем переданный диапазон дат или текущую дату по умолчанию
  const startDate = dateRange?.from ? normalizeDate(dateRange.from, false) : normalizeDate(new Date(), false)
  const endDate = dateRange?.to ? normalizeDate(dateRange.to, true) : normalizeDate(new Date(), true)

  return { startDate, endDate }
}

/**
 * Нормализует диапазон дат для списка рефералов (как в ReferralsTable)
 * @param dateRange - диапазон дат из DatePicker
 * @returns объект с startDate и endDate в формате ISO string
 */
export const normalizeDateRangeForList = (dateRange?: DateRange) => {
  // Используем переданный диапазон дат или текущую дату по умолчанию
  const startDate = dateRange?.from
    ? new Date(dateRange.from.getFullYear(), dateRange.from.getMonth(), dateRange.from.getDate(), 0, 0, 0, 0).toISOString()
    : undefined

  const endDate = dateRange?.to
    ? new Date(dateRange.to.getFullYear(), dateRange.to.getMonth(), dateRange.to.getDate(), 23, 59, 59, 999).toISOString()
    : undefined

  return { startDate, endDate }
}
